interface TenantSelector {
  organization?: string;
  organization_name?: string;
}

interface SessionTenant {
  id?: string;
  slug?: string;
}

/**
 * Whether a login link asks for a tenant other than the one the session is already in.
 *
 * Auth0's own links carry both the id and the name and they always agree, so the id decides
 * when both are present, matching Auth0's precedence.
 *
 * Two callers have to agree on this exactly: the login page, which re-authenticates through
 * Auth0 when it is true, and useAuthGuard, which must not redirect the page away before that
 * happens. If they disagree in the other direction - guard holding off while the login page
 * does nothing - the user is left on the spinner, so this is deliberately one function.
 */
export const isTenantSwitchRequested = (
  {organization, organization_name}: TenantSelector,
  tenant: SessionTenant | undefined,
): boolean => {
  if (organization) return organization !== tenant?.id;

  return !!organization_name && organization_name !== tenant?.slug;
};
